import { render, staticRenderFns } from "./appeal.vue?vue&type=template&id=c8ba239a&scoped=true"
import script from "./appeal.vue?vue&type=script&lang=js"
export * from "./appeal.vue?vue&type=script&lang=js"
import style0 from "./appeal.vue?vue&type=style&index=0&id=c8ba239a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ba239a",
  null
  
)

export default component.exports